<template>
  <div class="content">
    <div class="content-box factry-info">
      <el-form :model="form" ref="form" label-width="150px" label-position="top">
        <div class="form-box">
          <p class="form-title">
            {{ $t('crm_renter_item_info_us.gong_si_xin_xi') }}
          </p>
          <el-row class="form-container" :gutter="20">
            <el-col :span="8" class="form-left">
              <el-form-item :label="$t('crm_renter_item_info_us.gong_si_ming_cheng')" prop="partnerName" :rules="rules.partnerName">
                <el-input v-model="form.partnerName" style="width: 100%"></el-input>
              </el-form-item>
              <el-form-item :label="$t('crm_renter_item_info_us.shi_qu')" prop="timeZoneId" :rules="rules.timeZoneId" v-if="this.timeZoneList.length > 1">
                <custom-select v-model="form.timeZoneId" :data="timeZoneList" :auto="false" :props="{ label: 'timeZoneRegionDesc', value: 'timeZoneId' }"></custom-select>
              </el-form-item>
              <el-form-item :label="$t('crm_renter_item_info_us.gong_si_dian_hua')" prop="telephone" :rules="rules.telephone">
                <el-input v-model="form.telephone" style="width: 100%"></el-input>
              </el-form-item>
              <el-form-item :label="$t('crm_renter_item_info_us.gong_si_wang_zhi')" prop="website" :rules="rules.website">
                <el-input v-model="form.website" style="width: 100%"></el-input>
              </el-form-item>
              <el-form-item :label="$t('crm_renter_item_info_us.gong_si_miao_shu')" prop="partnerDesc" :rules="rules.partnerDesc">
                <el-input type="textarea" v-model="form.partnerDesc" style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" class="form-center">
              <el-form-item :label="$t('crm_renter_item_info_us.tyshxydmyyzzbh')" prop="businessLicense" :rules="erpCodeRequired ? [] : rules.businessLicense">
                <el-input v-model.trim="form.businessLicense" :disabled="!!partnerId && !funcView.partner_renter_license" style="width: 100%"></el-input>
              </el-form-item>
              <el-form-item :label="$t('crm_renter_item_info_us.gong_si_you_xiang')" prop="email" :rules="rules.email">
                <el-input v-model="form.email" style="width: 100%"></el-input>
              </el-form-item>
              <el-form-item :label="$t('crm_renter_item_info_us.gong_si_di_zhi')" prop="address">
                <custom-address-select :placeholder="$t('Common.com_please_select')" v-model="form.address" ref="address" style="width: 100%"></custom-address-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" class="form-left">
              <el-form-item :label="$t('crm_renter_item_info_us.ERPbian_hao')" prop="partnerCode" :rules="erpCodeRequired ? [] : rules.partnerCode">
                <el-input v-model.trim="form.partnerCode" style="width: 100%"></el-input>
              </el-form-item>
              <el-form-item :label="$t('crm_renter_item_info_us.gong_si_gui_mo')" prop="partnerScale">
                <custom-select :placeholder="$t('Common.com_please_select')" v-model="form.partnerScale" code="crm_partner_scale" width="100%"></custom-select>
              </el-form-item>
              <el-form-item :label="$t('crm_renter_item_info_us.gsxxdz')" prop="detailAddress">
                <el-input v-model="form.detailAddress" style="width: 100%"></el-input>
              </el-form-item>
              <!-- <el-row :gutter="8">
                <el-col :span="18">
                  <el-form-item :label="$t('label_registeredCapital')" prop="registeredCapital" :rules="rules.registeredCapital">
                    <el-input type="number" :min="0" v-model.number="form.registeredCapital" style="width: 100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('label_currencyUnit')" prop="currencyUnit" :rules="rules.currencyUnit">
                    <custom-select :placeholder="$t('com_please_select')" v-model="form.currencyUnit" code="isynergy_cloud_currency" width="100%"></custom-select>
                  </el-form-item>

                </el-col>
              </el-row> -->
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
    <div class="btn-group">
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="saveInfo">{{ $t('crm_renter_item_info_us.xyblxrxx') }}</el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import customAddressSelect from '@/components/customAddressSelect.vue';

export default {
  components: { customAddressSelect },
  props: {
    partnerId: [String, Number],
    orgId: [String, Number],
  },
  data() {
    // 密码验证
    return {
      cascaderProps: {
        value: 'code',
        label: 'value',
      },
      form: {
        partnerName: '',
        partnerClass: '1',
        partnerCode: '',
        telephone: '',
        email: '',
        partnerScale: '',
        address: '', // 自用不参与交互
        detailAddress: '',
        // nonMetric: '0',

        website: '',

        partnerDesc: '',
        timeZoneId: '', // 总部时区
        timeZone: '', // 总部时区
        timeZoneName: '', // 时区名称
        reportOffset: '', // 报表生成时间偏移量
        partnerType: 'CS', // 总部 HQ 售后公司SC 总代理 JV 大客户CO 公司CS
        enterpriseType: '1', // 1-企业，2-个体工商户，3-事业单位，4-宗教活动场所，5-其他 售后公司只能是企业1
        // 地址
        country: '',
        countryCode: '',
        province: '',
        provinceCode: '',
        city: '',
        cityCode: '',
        // 营业执照
        businessLicense: '',
        // 纳税人识别号
        buyerNumber: '',
        // 修改的
        extendId: '',
        orgId: '',
      },
      timeZoneList: [],
      // 公司ID
      factoryId: '',
      // ERP编号权限
      erpCodeRequired: false,
    };
  },
  watch: {
    partnerId(val) {
      this.factoryId = val || '';
      this.getCompanyDetail();
    },
    orgId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.form.orgId = val;
        }
      },
    },
  },
  computed: {
    rules() {
      return {
        // 基本信息
        partnerName: [
          {
            type: 'string',
            required: true,
            message: this.$t('crm_renter_item_info_us.qtxgsmc'),
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]) },
        ],
        partnerType: { required: true, message: this.$t('crm_renter_item_info_us.qxzgslx') },
        timeZoneId: [
          {
            required: true,
            message: this.$t('crm_renter_item_info_us.qing_xuan_ze_shi_qu')
          },
        ],
        partnerCode: [
          {
            type: 'string',
            required: true,
            message: this.$t('crm_renter_item_info_us.qtxERPbh'),
          },
          { max: 20, message: this.$t('Common.com_rules_length_max', [20]) },
        ],
        telephone: [
          {
            validator: null,
            message: this.$t('crm_renter_item_info_us.cdyz713gzf'),
          },
        ],
        email: [
          {
            type: 'email',
            message: this.$t('crm_renter_item_info_us.yxgsbzq'),
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]) },
        ],
        partnerScale: {
          required: true,
          message: this.$t('crm_renter_item_info_us.qxzgsgm'),
        },
        businessLicense: [
          {
            required: true,
            message: this.$t('crm_renter_item_info_us.qtxtyshxydmyyzzbh'),
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]) },
        ],
        buyerNumber: [
          {
            required: true,
            message: this.$t('crm_renter_item_info_us.qtxnsrsbhswdjbh'),
          },
          {
            min: 6,
            max: 50,
            message: this.$t('crm_renter_item_info_us.cdyz650gzf'),
          },
        ],
        address: [
          {
            required: true,
            type: 'array',
            message: this.$t('crm_renter_item_info_us.qxzgsdz'),
          },
        ],
        detailAddress: [
          {
            type: 'string',
            required: true,
            message: this.$t('crm_renter_item_info_us.qtxgsxxdz'),
          },
          { max: 100, message: this.$t('Common.com_rules_length_max', [100]) },
        ],

        website: { max: 100, message: this.$t('Common.com_rules_length_max', [100]) },
        registeredCapital: {
          type: 'number',
          min: 0,
          message: this.$t('crm_renter_item_info_us.zczjbnxy0'),
        },
        legalPerson: [
          {
            required: true,
            message: this.$t('crm_renter_item_info_us.qtxfrxm'),
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]) },
        ],
        legalPersonIdentity: [
          {
            required: true,
            message: this.$t('crm_renter_item_info_us.qtxfrsfzhm'),
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]) },
        ], // 数字或字母
        partnerDesc: { max: 200, message: this.$t('Common.com_rules_length_max', [200]) },
        imageLicense: {
          type: 'string',
          required: true,
          message: this.$t('crm_renter_item_info_us.qscyyzz'),
        },
        imageIdFace: {
          type: 'string',
          required: true,
          message: this.$t('crm_renter_item_info_us.qscsfzzfm'),
        },
        imageIdReverse: {
          type: 'string',
          required: true,
          message: this.$t('crm_renter_item_info_us.qscsfzghm'),
        },
        depositBank: {
          type: 'string',
          required: true,
          message: this.$t('crm_renter_item_info_us.qtxkhyh'),
        },
        depositNumber: {
          type: 'string',
          required: true,
          message: this.$t('crm_renter_item_info_us.qtxdgzh'),
        },
      };
    },
  },
  mounted() {
    // this.factoryId = this.getJump('factoryId');
    this.factoryId = this.partnerId || '';
    // ocr识别权限全在总部上管理
    this.getFuncView('/customer/renter');
    this.rules.registeredCapital.validator = (rule, value, callback) => {
      if (value && !(/(^[1-9]\d*$)/).test(value)) {
        callback(new Error());
      } else {
        callback();
      }
    };
    this.rules.telephone[0].validator = (rule, value, callback) => {
      if (value) {
        this.$mobilePhoneValidator(rule, value, callback);
      } else {
        callback();
      }
    };
    this.getCompanyDetail();
    // 查字典
    this.getDictionary('cloud_erpCode_control', () => {
      this.erpCodeRequired = this.$searchSiteCodeFunction('cloud_erpCode_control');
    });
  },
  methods: {
    getCompanyDetail: function () {
      if (!this.factoryId) {
        this.getTimeZoneList(true);
        return;
      }
      this.$getJSON(apis.partnerInfo, { partnerId: this.factoryId }).then((res) => {
        if (res.code === 0) {
          const data = res.data;
          this.$setFormatData(this.form, data);
          this.form.address = [];
          if (data.countryCode) {
            this.form.address.push(data.countryCode);
          }
          if (data.provinceCode) {
            this.form.address.push(data.provinceCode);
          }
          if (data.cityCode) {
            this.form.address.push(data.cityCode);
          }
          this.form.partnerClass = `${data.partnerClass}`;
          this.form.currencyUnit = `${data.currencyUnit}`;
          // this.form.timeZone = `${data.timeZone}`;
          this.form.partnerType = data.partnerType;
          // 数字转字符串
          this.form.registeredCapital = +data.registeredCapital;
          // 营业执照
          this.businessLicenseImageList = this.businessLicenseImageList || [];
          this.idImageList = this.idImageList || [];
          this.getTimeZoneList(false);
        }
      });
    },
    // 获取时区列表
    getTimeZoneList: function (isInit) {
      this.$getJSON(apis.timeZoneGetCompanyList, { orgId: this.orgId }).then((res) => {
        this.timeZoneList = res.data;
        if (this.timeZoneList.length > 0 && isInit) {
          this.form.timeZoneId = this.timeZoneList[0].timeZoneId;
        }
      });
    },
    // 取消
    onCancel: function () {
      this.$emit('cancel');
    },
    // onBankCode: function (item) {
    //   if (item) {
    //     this.form.bankName = item.bankName || '';
    //   } else {
    //     this.form.bankName = '';
    //   }
    // },
    // 保存基本信息
    saveInfo: async function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        // 赋值 国家城市镇区
        const addressMsg = this.$refs.address.getAddressMsg();
        this.$setFormatData(this.form, addressMsg);
        // 保存交互
        if (this.factoryId) {
          // factoryId 公司id  编辑要放进参数里面
          this.form.partnerId = this.factoryId;
          this.$postJSON(apis.crmPartnerUpdate4Simple, this.form).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: this.$t('Common.com_modify_success'),
                type: 'success',
              });
              this.$emit('success', 2);
              // this.jump('/distributor/serviceCompany', { refresh: true }, true);
            }
          });
        } else {
          //
          this.$postJSON(apis.crmPartnerAdd4Simple, this.form).then((res) => {
            this.$emit('syncPartnerId', res.data.partnerId, res.data.partnerOrgId);
            this.$emit('success', 2);
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import '../../../../style/colors.scss';
.factry-info {
  padding: 14px 24px 0;
  .form-box {
    margin-top: 35px;
    position: relative;
    width: 100%;
    border: 1px solid rgba(13, 154, 224, 0.3);
    padding: 34px 24px 24px;
    .form-container {
      width: 1100px;
      display: flex;
      // .form-container-left {
      //   width: 100% !important;
      //   margin-right:24px;
      // }
      // .form-container-right {
      //   width: 100% !important;
      //   flex: 0 0 100%;
      // }
    }
    .form-title {
      font-size: 12px;
      font-weight: 600;
      color: rgba(13, 154, 224, 1);
      line-height: 20px;
      height: 20px;
      position: absolute;
      top: -10px;
      left: 16px;
      background: #ffffff;
      padding: 0 10px;
    }
    .tip {
      background: rgba(53, 184, 224, 0.15);
      border-radius: 2px;
      margin: 8px 0 24px;
      padding-left: 10px;
      .icon {
        color: #0d9ae0;
        font-size: 12px;
        margin-right: 10px;
      }
      span {
        line-height: 32px;
        color: #6c757d;
        font-size: 12px;
      }
    }

    .tips {
      color: #aeb5bd;
      font-size: 12px;
      line-height: 16px;
      margin-top: 6px;
    }
  }
}
</style>
